// removed by extract-text-webpack-plugin
module.exports = {"restore-wrapper-D":"restore-wrapper-D","restore-title":"restore-title","restore-form":"restore-form","restore-input-group":"restore-input-group","restore-input":"restore-input","restore-icon":"restore-icon","restore-btn":"restore-btn","restore-to-register":"restore-to-register","register-link":"register-link"};


//////////////////
// WEBPACK FOOTER
// ./components/restore-password/_RestorePasswordForm.scss
// module id = ./components/restore-password/_RestorePasswordForm.scss
// module chunks = 0